(function () {
  var root = document.querySelector("[data-print-sets]");
  if (!root) return;
  var buttons = root.querySelectorAll("[data-set-filter]");
  function apply(key) {
    Array.prototype.forEach.call(buttons, function (btn) {
      btn.setAttribute("aria-pressed", btn.getAttribute("data-set-filter") === key ? "true" : "false");
    });
    Array.prototype.forEach.call(root.querySelectorAll("[data-print-set]"), function (row) {
      if (key === "all") {
        row.hidden = false;
        return;
      }
      var tags = row.getAttribute("data-set-tags") || "";
      row.hidden = (" " + tags + " ").indexOf(" " + key + " ") === -1;
    });
  }
  Array.prototype.forEach.call(buttons, function (btn) {
    btn.addEventListener("click", function () {
      apply(btn.getAttribute("data-set-filter"));
    });
  });

  function channel(part) {
    var value = part / 255;
    return value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
  }
  function darkWall(hex) {
    var bits = /^#([0-9a-f]{6})$/i.exec(hex || "");
    if (!bits) return false;
    var n = parseInt(bits[1], 16);
    var light = 0.2126 * channel((n >> 16) & 255) + 0.7152 * channel((n >> 8) & 255) + 0.0722 * channel(n & 255);
    return light < 0.45;
  }
  root.addEventListener("input", function (event) {
    var input = event.target;
    if (!input.matches || !input.matches("[data-set-wall]")) return;
    var row = input.closest("[data-print-set]");
    var frames = row && row.querySelector("[data-set-frames]");
    if (!frames) return;
    frames.style.setProperty("--set-wall", input.value);
    frames.classList.add("has-wall");
    frames.classList.toggle("is-dark", darkWall(input.value));
    var swatch = input.closest(".print-set-wall-swatch");
    if (swatch) swatch.style.background = input.value;
  });
  Array.prototype.forEach.call(root.querySelectorAll("[data-set-wall]"), function (input) {
    var swatch = input.closest(".print-set-wall-swatch");
    if (swatch) swatch.style.background = input.value;
  });

  function encodePlan(plan) {
    return btoa(unescape(encodeURIComponent(JSON.stringify(plan)))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  }
  Array.prototype.forEach.call(root.querySelectorAll("[data-set-plan]"), function (node) {
    var row = node.closest("[data-print-set]");
    var link = row && row.querySelector("[data-set-plan-link]");
    if (!link) return;
    try {
      var plan = JSON.parse(node.textContent);
      var url = new URL(link.getAttribute("href"), window.location.origin);
      url.searchParams.set("set", encodePlan(plan));
      link.href = url.toString();
    } catch (err) {}
  });

  var artistLink = document.querySelector(".artist-sets [data-set-plan-link]");
  var planWall = document.querySelector("a.artist-wall-link");
  if (artistLink && planWall) planWall.href = artistLink.href;
})();
